import { type SupportedCountry as KycSupportedCountry } from "../components/interface";

/**
 * Enum for IDV Service depend on country.
 * @readonly
 * @enum {string}
 */
export enum IDVServiceEnum {
  STRIPE = "Stripe",
  ID_NOW = "IDnow",
}

export const getJurisdictionIDVService = (country: KycSupportedCountry): IDVServiceEnum => {
  switch (country) {
    case "DE":
      return IDVServiceEnum.ID_NOW;
    default:
      return IDVServiceEnum.STRIPE;
  }
};
